import { useTranslation } from 'react-i18next';
import { store } from 'src/state/dynamic-store';
import { RootState } from '@state/root-state.ts';
import { useSelector } from 'react-redux';
import { FreeFieldsComponentWrapper } from '@sharedComponents/free-fields/FreeFieldsComponent';
import Paper from '@mui/material/Paper';
import styles from './FreeFieldsPage.module.scss';
import { CdfBreadcrumbs } from '@commonComponents/navigation/CdfBreadcrumbs';

export function FreeFieldsPage() {
  const { t } = useTranslation(['layouts']);
  const organizationId = useSelector((state: RootState) => state.appContext.selectedOrganizationId ?? '');

  return (
    <>
      <CdfBreadcrumbs items={[{ label: t('breadCrumbs.freeFields.page') }]} />
      <Paper className={styles.container}>
        <FreeFieldsComponentWrapper organizationId={organizationId} store={store}></FreeFieldsComponentWrapper>
      </Paper>
    </>
  );
}
